import { OEAsset, useClient, useContents, useDictionary } from "@adamlip/okeoke.client"
import { Card, CardBody, CardFooter, cn } from "@nextui-org/react"
import CouponModalV2 from "components/Modals/CouponModalV2"
import OrderItemModalV3 from "components/Modals/OrderItemModalV3"
import { BasketContext } from "contexts/BasketContext"
import { UserContext } from "contexts/UserContext"
import useStorage from "hooks/useStorage"
import { useContext, useEffect, useState } from "react"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"
import { Swiper, SwiperSlide } from "swiper/react"

export default function ContentBox({ place, categoryUUID }) {
  const { setIsUserSelectedLocation } = useContext(BasketContext)
  const {
    coupons,
    activateCoupon,
    refreshCoupons
  } = useContext(UserContext)

  const { getValue } = useDictionary()

  const { contents } = useContents()

  const { getName, languageCode, setSelectedLocation } = useClient()
  const { setSV } = useStorage()

  const [boxData, setBoxData] = useState(null)
  const [orderItemModalOpen, setOrderItemModalOpen] = useState(false)
  const [selectedItemUUID, setSelectedItemUUID] = useState(null)
  const [activateInProgress, setActivateInProgress] = useState(false)

  const [selectedCoupon, setSelectedCoupon] = useState(null)

  const navigate = useNavigate()

  const handleClick = (item) => {
    console.log(item)
    if (item?.action === "selectLocation" && item?.params?.locationUUID) {
      setSelectedLocation(item?.params?.locationUUID)
      setIsUserSelectedLocation(true)
      navigate(`/order`)
    }
    if (item?.action === "navigateToCoupons") {
      navigate(`/coupons/all`)
    }
    if (item?.action === "openItem" && item?.params?.itemUUID) {
      setSelectedItemUUID(item?.params?.itemUUID)
      setOrderItemModalOpen(true)
    }
    if (item?.action === "openCateg" && item?.params?.categUUID) {
      navigate(`/order?categoryUUID=${item?.params?.categUUID}`)
      setSV("selectedCategory", item?.params?.categUUID)
    }
    if (item?.action === "createExternalLink" && item?.params?.externalLink) {
      window.open(item?.params.externalLink)
    }
    if (item?.action === "selectCoupon" && item?.params?.couponID) {
      let coupon = coupons?.find(coupon => coupon.id === item?.params?.couponID)
      if (coupon) {
        setSelectedCoupon(coupon)
      } else {
        toast.error(getValue("app_v2_coupons_not_found"))
      }
    }
  }

  const handleActivateCoupon = (coupon) => {
    if (coupon?.active) return null
    setActivateInProgress(coupon?.code)
    activateCoupon(coupon?.code, false).then((response) => {
      if (response?.success) {
        toast.success(getValue("app_v2_coupons_activated"))
        refreshCoupons()
      }
      setActivateInProgress(false)
      setSelectedCoupon(null)
    })
  }

  const handleDeActivateCoupon = (coupon) => {
    if (!coupon?.active) return null
    setActivateInProgress(coupon?.code)
    activateCoupon(coupon?.code, true).then((response) => {
      if (response?.success) {
        toast.success(getValue("app_v2_coupons_deactivated"))
        refreshCoupons()
      }
      setActivateInProgress(false)
      setSelectedCoupon(null)
    })
  }

  useEffect(() => {
    let contentArray = []
    if (contents != null) {
      for (let content of Object.values(contents || {})) {
        if ((content?.contentPlacement || [])?.includes(place)) {
          if (categoryUUID != null) {
            if (content?.params?.categories?.includes(categoryUUID)) {
              contentArray.push(content)
            }
          } else {
            contentArray.push(content)
          }
        }
      }
    }
    setBoxData(contentArray?.[0])
  }, [contents, place, categoryUUID])

  if (!boxData || boxData?.contentElements?.length === 0) return null
  return (
    <div className="w-[400px] max-w-full p-1 m-auto md:m-0">
      <div className="aspect-ratio">
        <div className="w-full h-full rounded-[var(--general-border-radius)] ">
          {orderItemModalOpen && selectedItemUUID && (
            <OrderItemModalV3
              isOpen={orderItemModalOpen}
              setIsOpen={setOrderItemModalOpen}
              itemUUID={selectedItemUUID}
            />
          )}
          {selectedCoupon && <>
            <CouponModalV2
              isOpen={selectedCoupon}
              setIsOpen={() => setSelectedCoupon(null)}
              coupon={selectedCoupon}
              setCurrentCoupon={setSelectedCoupon}
              currentCoupon={selectedCoupon}
              handleActivateCoupon={handleActivateCoupon}
              handleDeActivateCoupon={handleDeActivateCoupon}
              activateInProgress={activateInProgress}
            />
          </>}
          <Swiper
            spaceBetween={0}
            slidesPerView={1}
            //pagination={{ clickable: true }}
            //    autoplay={{delay: 3000}}

            loop={true}
          >
            {boxData?.contentElements?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="rounded-[var(--general-border-radius)] h-full"
                >
                  <SwiperSlide
                    key={index}
                    className="rounded-[var(--general-border-radius)] "
                  >
                    <Card
                      className="rounded-[var(--general-border-radius)] h-full"
                      classNames={{
                        base: cn("data-[pressed=true]:scale-[0.9]"),
                      }}
                      isPressable
                      onClick={() => {
                        handleClick(item)
                      }}
                    >
                      <CardBody className="p-0 overflow-hidden">
                        {item.image?.uuid != null &&
                          item.image?.uuid !== "" && (
                            <div className="">
                              <OEAsset
                                uuid={item.image?.uuid}
                                addClass={"w-full h-full object-cover"}
                                size="l"
                              />
                            </div>
                          )}
                      </CardBody>
                      {((item?.title?.[languageCode] != null &&
                        item?.title?.[languageCode].length > 0) ||
                        (item?.text?.[languageCode] != null &&
                          item?.text?.[languageCode].length > 0)) && (
                          <CardFooter className="absolute bg-background/40 bottom-0 overflow-hidden z-10 border-t-1 border-background dark:border-default-100">
                            <div className="flex flex-grow gap-2 items-center max-w-[80%] ">
                              <div className="flex flex-col w-full">
                                <p className="text-tiny font-bold text-left ">
                                  {getName(item?.title)}
                                </p>
                                <p className="text-tiny font-medium text-left opacity-60 grow truncate">
                                  {getName(item?.text)}
                                </p>
                              </div>
                            </div>
                            {/* {(item?.params?.itemUUID || item?.params?.categUUID) && (
                      <Button onPress={() => handleClick(item)} color='primary' radius='full' size='sm' className='w-auto'>
                        {item?.params?.itemUUID ? getValue('app_v2_contentBox_openItem') : item?.params?.categUUID ? getValue('app_v2_contentBox_openCategory') : ''}
                      </Button>
                    )} */}
                          </CardFooter>
                        )}
                    </Card>
                  </SwiperSlide>
                </div>
              )
            })}
          </Swiper>
        </div>
      </div>
    </div>
  )
}
